import { TIER_ORDER } from './consts';
import { PerformanceTier, PerformerStatus, Tier } from './types';
import { TargetingValues } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
/** A status for a merchant enrolled in the programme, i.e. holding one of the performance tiers. */
export interface EnrolledPerformerStatus extends PerformerStatus {
  tier: PerformanceTier;
}

export function isEnrolled(status: PerformerStatus): status is EnrolledPerformerStatus {
  return status.tier !== 'NOT_ELIGIBLE';
}

export function countCompletedGoals(status: PerformerStatus): number {
  return status.goal_statuses.filter((goal) => goal.state === 'COMPLETED').length;
}

/** The tier directly above `tier`, or undefined when it is already the highest (or NOT_ELIGIBLE). */
export function getNextTier(tier: Tier): PerformanceTier | undefined {
  const currentTierIndex = TIER_ORDER.findIndex((orderedTier) => orderedTier === tier);
  return currentTierIndex >= 0 ? TIER_ORDER[currentTierIndex + 1] : undefined;
}

export function isTopPerformerEnabled(targetingParameters: TargetingValues) {
  return Boolean(targetingParameters.delivery_provider_portal_flags.enable_top_performer);
}
